import { render, staticRenderFns } from "./action.vue?vue&type=template&id=8000c78c&scoped=true&lang=pug"
import script from "./action.vue?vue&type=script&lang=js"
export * from "./action.vue?vue&type=script&lang=js"
import style0 from "./action.vue?vue&type=style&index=0&id=8000c78c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8000c78c",
  null
  
)

export default component.exports